import { motion } from "framer-motion";
import { Container, Row, Col } from "react-bootstrap";
import TaxDeduction from "../assets/tax-deduction.jpg";

const DeductionSection = () => {
  return (
    <section className="deduction-section d-flex align-items-center">
      <Container>
        <Row className="align-items-center">
          {/* Image Section */}
          <Col
            md={6}
            className="text-center mb-5 mb-md-0 d-flex justify-content-center"
          >
            <motion.img
              src={TaxDeduction}
              alt="Tax Deduction"
              className="img-fluid rounded-4 shadow-lg deduction-img"
              initial={{ opacity: 0, x: -60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }} // <-- animation only plays once
            />
          </Col>

          {/* Text Section */}
          <Col md={6}>
            <motion.div
              initial={{ opacity: 0, x: 60 }}
              whileInView={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.6 }}
              viewport={{ once: true }} // <-- animation only plays once
            >
              <h2 className="mb-4 text-dark fw-bolder display-5">
                Tired of missing Deductions? You are not alone.
              </h2>
              <p className="text-dark fs-5 mb-4 lh-base">
                Many freelancers and business owners overpay their taxes every
                year simply because they forget to claim deductible expenses.
                Manual tracking is stressful, error-prone, and time-consuming.
              </p>
              <p className="text-secondary fw-sm">
                <strong>WriteOffGenie</strong> makes it effortless — powered by
                AI that never misses a write-off.
              </p>
            </motion.div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default DeductionSection;
